// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3usbP","icon":"Button_icon__ENZwq"};